
/**
 * 토픽 상세 정보
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenDetails = {
  description?: string;
};
